// extracted by mini-css-extract-plugin
export var container = "_dk-0";
export var icon = "_dk-1";
export var text = "_dk-2";